// extracted by mini-css-extract-plugin
module.exports = {"search-bar":"Payments_search-bar__1rWNf"};